export default __webpack_public_path__ + "static/media/icon-filetype-png.fcc6c275.svg";